import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import HeaderAndFooterLabel from './HeaderAndFooterLabel';
import LineAtCoordinates from 'src/components/LineAtCoordinates/LineAtCoordinates';

const Wrapper = styled.div`
  opacity: ${({ isActive }) => isActive ? '1' : '.5'};
  transition: opacity ${({ theme }) => theme.Transition.Timing.out}

  &:hover {
    opacity: 1;
    transition: opacity ${({ theme }) => theme.Transition.Timing.in}
  }
`;

export default function HeaderAndFooterLine ({
  x1, x2,
  y1, y2,
  label,
  lineStyle = 'solid',
  isActive = true
}) {
  return (
    <Wrapper isActive={isActive}>
      <LineAtCoordinates
          x1={x1} x2={x2}
          y1={y1} y2={y2}
          lineStyle={lineStyle}
      >
        {label && <HeaderAndFooterLabel {...label} />}
      </LineAtCoordinates>
    </Wrapper>
  );
}

HeaderAndFooterLine.propTypes = {
  x1: PropTypes.number.isRequired,
  x2: PropTypes.number.isRequired,
  y1: PropTypes.number.isRequired,
  y2: PropTypes.number.isRequired,
  label: PropTypes.object,
  lineStyle: PropTypes.string,
  isActive: PropTypes.bool
};
